const { client, loadToken } = require('services/api/client');
export { loadToken };


export async function postGhostBus(data) {
    var { data } = await client.post(`/stopmonitor/ghostBus`, data);
    return data;
}

export async function getInspectionsByStopID(stop_id) {
    var { data } = await client.get(`/inspections/stopid/${stop_id}`);
    return data;
}

export async function getInspectionsByUUID(uuid) {
    var { data } = await client.get(`/inspections/uuid/${uuid}`);
    return data;
}

export async function getInspectionByRecordID(inspection_record_id) {
    var { data } = await client.get(`/inspections/record/${inspection_record_id}`);
    return data;
}

export async function getAllInspectionsByRecordID(inspection_record_id) {
    var { data } = await client.get(`/inspections/records/${inspection_record_id}`);
    return data;
}

export async function getAllInspectionsForUser() {
    var { data } = await client.get(`/inspections`);
    return data;
}

export async function getAllMaintenanceTags() {
    var { data } = await client.get(`/inspections/maintenance-tags`);
    return data;
}

export async function getAllDeviceMaintenanceTags() {
    var { data } = await client.get(`/inspections/maintenance-tags/device`);
    return data;
}

export async function addNewInspection(body, onProgressUpdate) {
    var { data } = await client.post('inspections/new', body, {
        onUploadProgress: (progressEvent) => {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            if (onProgressUpdate) onProgressUpdate(percent);
        }
    });

    return data;
}

export async function addNewRectification(body, onProgressUpdate) {
    var { data } = await client.post('inspections/rectify', body, {
        onUploadProgress: (progressEvent) => {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            if (onProgressUpdate) onProgressUpdate(percent);
        }
    });

    return data;
}

export async function editInspection(inspection_record_id, body) {
    var { data } = await client.put(`/inspections/record/${inspection_record_id}`, body);
    return data;
}

export async function deleteInspection(inspection_record_id) {
    var { data } = await client.delete(`/inspections/record/${inspection_record_id}`);
    return data;
}

export async function updateInspectionStatus(inspection_record_id) {
    var { data } = await client.put(`/inspections/record/status/${inspection_record_id}`);
    return data;
}

export async function updateInspectionScheduling(inspection_record_id) {
    var { data } = await client.put(`/inspections/record/scheduling/${inspection_record_id}`);
    return data;
}

const all = {
    loadToken, getInspectionsByStopID, addNewInspection, addNewRectification, updateInspectionStatus, updateInspectionScheduling,
    getInspectionsByUUID, getAllInspectionsForUser, getInspectionByRecordID, deleteInspection, getAllMaintenanceTags,
    getAllDeviceMaintenanceTags, getAllInspectionsByRecordID, editInspection
};

export default all;